<div class="forgot-password-container">
  <div class="card">
    <div class="card-header text-center">
      <h2>Reset Password</h2>
    </div>
    <div class="card-body">
      <!-- Success Message -->
      <div *ngIf="showSuccess" class="alert alert-success mb-3">
        <i class="bi bi-check-circle-fill me-2"></i>
        {{ successMessage }}
      </div>

      <!-- Error Message -->
      <div *ngIf="showError" class="alert alert-danger mb-3">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>
        {{ errorMessage }}
      </div>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
        <!-- Email Address -->
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <div class="input-group">
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-control"
              [ngClass]="{'is-invalid': isInvalid('email')}"
              autocomplete="email"
              placeholder="Enter your email"
            />
          </div>
          <div class="validation-message" *ngIf="isInvalid('email')">
            <div *ngIf="hasError('email', 'required')">
              Email is required
            </div>
            <div *ngIf="!hasError('email', 'required') && hasError('email', 'email')">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <!-- Turnstile CAPTCHA -->
        <div class="form-group">
          <app-turnstile
            [siteKey]="siteKey"
            (tokenChange)="onTurnstileToken($event)"
            #turnstileWidget
          ></app-turnstile>
        </div>

        <!-- Reset Button -->
        <div class="form-group text-center button-container">
          <button
            type="submit"
            class="btn btn-secondary"
            [disabled]="!isFormReady || !turnstileToken"
          >
            Reset Password
          </button>
        </div>

        <!-- Sign Up Link -->
        <div class="form-group text-center mt-3">
          <div class="form-text">
            Don't have an account yet?
            <a class="form-link" routerLink="/contact-us">Contact us</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
